import { IconButton, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { ChangeEvent, useState } from 'react';
import styles from './styles';

interface IFilterProps {
    id?: string;
    searchChange?: (text: string) => void;
    placeholder?: string;
    disabled?: boolean;
}

export default function SearchWithoutFilter({ searchChange, id, placeholder, disabled = false }: IFilterProps) {
    const [value, setValue] = useState<string>('');

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value;
        setValue(val);
        if (searchChange) {
            searchChange(val);
        }
    };

    return (
        <>
            <Typography component="div" sx={styles.root}>
                <Typography component="div">
                    <TextField
                        id={id}
                        name="filter"
                        placeholder={placeholder}
                        type="text"
                        variant="outlined"
                        size="small"
                        onChange={onChange}
                        value={value}
                        sx={styles.autoComplete}
                        InputProps={{
                            endAdornment: value ? (
                                <IconButton
                                    id="clear-icon-btn"
                                    aria-label="toggle password visibility"
                                    onClick={() => {
                                        setValue('');
                                        if (searchChange) {
                                            searchChange('');
                                        }
                                    }}
                                >
                                    <img id="img-clear" src="/images/search-clear.svg" alt="close" />
                                </IconButton>
                            ) : (
                                <IconButton
                                    id="search-icon-btn"
                                    aria-label="toggle password visibility"
                                    onClick={() => {
                                        if (searchChange) {
                                            searchChange(value);
                                        }
                                    }}
                                >
                                    <img id="search" src="/images/search.svg" alt="search" />
                                </IconButton>
                            ),
                        }}
                        disabled={disabled}
                    />
                </Typography>
            </Typography>
        </>
    );
}
